export default __webpack_public_path__ + "static/media/refresh.8bc6319c.png";